import gql from 'graphql-tag';

export const GET_SECTIONS = gql`
  query GetSections($lessonId: MOID!) {
    getSections(lessonId: $lessonId) {
        _id
        title
        isPublished
        position
    }
  }
`;

export const GET_SECTION = gql`
  query GetSection($id: MOID!) {
    getSection(id: $id) {
      _id
      title
      position
      content {
        html
        label
        type
      }
      isPublished
    }
  }
`;

